import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './translations/resourcesEN';
import da from './translations/resourcesDA';

const resources = {
  en,
  da,
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',

  interpolation: {
    escapeValue: true,
  },
});

export default i18n;
